import React, {Component} from 'react';
import {styled} from '@material-ui/core/styles';
import {Box, Button, Snackbar, Typography, LinearProgress} from '@material-ui/core';
import {globalData, ADD, EDIT, VIEW, CHILD, NORMAL, SPOUSE, CLIENT, MANUAL, DRAFT} from '../../../../common/common';
import {egdeCollisions, deduplicationObjArr, newId} from '../../../../common/utils';
import EstateMenu from '../EstateMenu';
import EstateContent from './EstateContent';
import Alert from '@material-ui/lab/Alert';
import EstatePList from './EstatePList';
import EstateProcess from '../EstateProcess';
import AlertDialog from '../../../Layout/components/AlertDialog';

const Root = styled(Box)({
    width: '100%',
    '& .menuWapper': {
        width: '20%',
        height: '100%',
        backgroundColor: '#FAFAFA',
    },
    '& .contentWapper': {
        width: '70%',
        margin: '0 auto 50px auto',
        background: '#ffffff',
        padding: '24px',
        '& .cTop': {
            width: '100%',
            '& .pageTitle': {
                fontSize: '16px',
                fontWeight: 'bold',
                color: '#005E96',
            },
        },
        '& .cCenter': {
            width: '100%',
            overflowX: 'auto',
        },
        '& .cBottom': {
            width: '100%',
            '& .foot': {
                margin: '10px 0',
                '& .btn': {
                    width: '100px',
                    marginLeft: '10px',
                },
            },
        },
    },
    '& .listWapper': {
        width: '10%',
        height: '650px',
        backgroundColor: '#FAFAFA',
        overflowX: 'auto',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#A1A1A1',
        margin: '20px 0',
        opacity: '0.12',
    },
    '& .title': {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#212C31',
        marginTop: '18px',
    },
    '& .doc-type': {
        width: '200px',
        height: '26px',
        color: '#fff',
        fontSize: '12px',
        fontWeight: 'bold',
        borderRadius: '50px',
        backgroundColor: '#18C6FF'
    },
})

class EstateInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuData: [
                "DOCUMENT INFO",
                "1. CLIENT’S GENERAL INFO",
                "2. CHILDREN",
                "3. EXECUTOR (CLIENT)",
                "4. GUARDIAN (CLIENT)",
                "5. GENERAL POWER OF ATTORNEY (CLIENT)",
                "6. HEALTH-CARE AGENT (CLIENT)",
                "7. LIVING WILL (CLIENT)",
                "WILL (CLIENT)",
                "FINAL DISPOSITION (CLIENT)",
                "8. HIPAA INFORMATION RELEASE FORM (CLIENT)",
                "9. EXECUTOR (SPOUSE)",
                "10. GUARDIAN (SPOUSE)",
                "11. GENERAL POWER OF ATTORNEY (SPOUSE)",
                "12. HEALTH-CARE AGENT (SPOUSE)",
                "13. LIVING WILL (SPOUSE)",
                "WILL (SPOUSE)",
                "FINAL DISPOSITION (SPOUSE)",
                "14. HIPAA INFORMATION RELEASE FORM (SPOUSE)",
                "15a. TRUSTEE",
                "15b. DISTRIBUTION OF TRUST",
                "16. EMERGENCY GUARDIAN",
            ],
            detailsData: [
                "<strong>Welcome</strong>",
                "Please fill in the personal information of you and your spouse.",
                "Please list all living children.",
                "This person is responsible for handling your estate. Generally, the first choice is the spouse, followed by adult children, siblings, parents, friends, etc.",
                "This person who will assume guardianship of minor children until they turn 18 years old.",
                "This person will be responsible for taking care of your private affairs, business affairs, legal affairs, etc. should you be incapacitated.",
                "This person will be able to make medical decisions on your behalf should you become unconscious or otherwise be unable to do so on your own.",
                "This person will speak on your family’s behalf regarding medical decisions.",
                "WILL (CLIENT)",
                "FINAL DISPOSITION (CLIENT)",
                "These persons will be authorized to obtain your medical information and release it to doctors and other medical providers for your treatment.",
                "This person is responsible for handling your estate. Generally, the first choice is the spouse, followed by adult children, siblings, parents, friends, etc.",
                "This person who will assume guardianship of minor children until they turn 18 years old.",
                "This person will be responsible for taking care of your private affairs, business affairs, legal affairs, etc. should you be incapacitated.",
                "This person will be able to make medical decisions on your behalf should you become unconscious or otherwise be unable to do so on your own.",
                "This person will speak on your family’s behalf regarding medical decisions.",
                "WILL (SPOUSE)",
                "FINAL DISPOSITION (SPOUSE)",
                "These persons will be authorized to obtain your medical information and release it to doctors and other medical providers for your treatment.",
                "This person is responsible for the management and disposition of the trust’s assets. Placing assets in a trust helps to avoid probate and ensure that your estate is handled promptly and smoothly. For example, if you have investments or business interests, the trustee may make timely decisions as circumstances arise, without having to wait for the court’s probate proceedings. Other special requirements can also be accommodated, depending on your specific circumstances.",
                "Generally, Trusts (or Wills) distribute assets according to the terms of the document, which can " +
                "be to your direct descendants, to charities, or to other members of your family. By default, we " +
                "recommend splitting assets equally amongst your children, or grandchildren if any.<br/>" +
                "A specific consideration when completing this section should be how you would like to distribute " +
                "your assets if you have no direct descendants (i.e. no children or grandchildren). Under law, if " +
                "no designation is made, the assets will go to your parents if alive, and then to your siblings if any.<br/>" +
                "Please indicate in this section how you would like your assets to be distributed in the event you" +
                "do not have living children or grandchildren.",
                "The designated emergency guardian will assume temporary custody of minor children under the age of 18 in case of emergency",
            ],
            contentData: {},
            menuIndex: 0,
            offsetL: 0,
            offsetT: 0,
            dragData: null,
            prevState: false,
            showToast: false,
            pListData: [],
            processValue: 0,
            showAlert: false,
        }
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleMenuIndex = this.handleMenuIndex.bind(this);
        this.handlePrev = this.handlePrev.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleDown = this.handleDown.bind(this);
        this.handleMove = this.handleMove.bind(this);
        this.handleUp = this.handleUp.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.extractPList = this.extractPList.bind(this);
        this.updateInfoData = this.updateInfoData.bind(this);
        this.handleAlertYes = this.handleAlertYes.bind(this);
        this.handleAlertNo = this.handleAlertNo.bind(this);
    }

    render() {
        const {
            contentData,
            detailsData,
            menuData,
            menuIndex,
            showToast,
            offsetL,
            offsetT,
            dragData,
            pListData,
            processValue,
            showAlert,
        } = this.state;
        const {title, state, data, firstName} = this.props;
        const createBtn = () => {
            if (menuIndex === menuData.length - 1) {
                return <Button className="btn" variant="contained" color="secondary"
                               onClick={e => this.handleCreate(true)}>submit</Button>
            }
        }
        return (
            <Root id="estateInfo">
                <div className="h">
                    {/* <div className="menuWapper">
                        <EstateMenu
                            menuData={menuData}
                            menuIndex={menuIndex}
                            isLock={this.isLock()}
                            // isLock={false}
                            handleMenuIndex={this.handleMenuIndex}
                        />
                    </div> */}
                    <div className="contentWapper v">
                        <div className="cTop">
                            <div className="pageTitle h h-bt">
                                <EstateProcess
                                    menuData={menuData}
                                    menuIndex={menuIndex}
                                ></EstateProcess>
                                {/* <div>{title}</div> */}
                                {/*<div className="doc-type c">MARRIED WITH CHILDREN</div>*/}
                            </div>
                            <Box display="flex" alignItems="center" marginTop="16px">
                                <Box width="100%" mr={1}>
                                    <LinearProgress variant="determinate" value={processValue}/>
                                </Box>
                                <Box minWidth={35}>
                                    <Typography variant="body2" color="textSecondary">{`${Math.round(
                                        processValue,
                                    )}%`}</Typography>
                                </Box>
                            </Box>
                            <div className="line"></div>
                        </div>
                        <div className="cCenter f">
                            <EstateContent
                                menuData={menuData}
                                detailsData={detailsData}
                                contentData={contentData}
                                menuIndex={menuIndex}
                                state={state}
                                dragData={dragData}
                                firstName={firstName}
                                handleChange={this.handleChange}
                                ref={(child) => {
                                    this.estateContent = child
                                }}
                            />
                        </div>
                        <div className="cBottom">
                            <div className="line"></div>
                            <div className="foot h h-bt">
                                <div>
                                    <Button disabled={this.isNext("prev")} className="btn" variant="contained"
                                            color="primary" onClick={this.handlePrev}>PREVIOUS</Button>
                                    <Button disabled={this.isNext("next")} className="btn" variant="contained"
                                            color="primary" onClick={this.handleNext}>Next</Button>
                                </div>
                                <div>
                                    <Button className="btn" variant="contained" color="primary"
                                            onClick={e => this.handleCreate(false)}>save</Button>
                                    {createBtn()}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="listWapper v">
                        <EstatePList
                            contentData={contentData}
                            offsetL={offsetL}
                            offsetT={offsetT}
                            pList={pListData}
                            updateInfoData={this.updateInfoData}
                            handleDown={this.handleDown}
                            handleUp={this.handleUp}
                            handleMove={this.handleMove}
                        />
                    </div> */}
                </div>
                <Snackbar anchorOrigin={{vertical: "top", horizontal: "center"}} open={showToast}
                          autoHideDuration={3000} onClose={this.handleClose}>
                    <Alert severity="warning">
                        {globalData.toastMsg}
                    </Alert>
                </Snackbar>
                <AlertDialog
                    open={showAlert}
                    title="Warning"
                    content="You will be unable to modify your information after submission, are you sure to continue?"
                    handleAlertYes={this.handleAlertYes}
                    handleAlertNo={this.handleAlertNo}
                ></AlertDialog>
            </Root>
        )
    }

    componentDidMount() {
        const {data} = this.props;
        const estateDom = document.getElementById("estateInfo");
        const offsetL = estateDom.getBoundingClientRect().left;
        const offsetT = estateDom.getBoundingClientRect().top;
        this.setState(() => ({
            offsetL,
            offsetT,
        }))
        this.initGlobalData();
        this.initData(data);
    }

    componentDidUpdate(prevProps) {
        const {
            data,
        } = this.props;
        console.log(data);
        if (prevProps.data !== data) {
            if (data) {
                this.initData(data);
            }
        }
    }

    initData(data) {
        let pListData = [];
        let processValue = 0;
        if (data && Object.keys(data.content).length > 0) {
            processValue = this.countProcessVlue(data.content);
            pListData = data;
            this.setState({
                contentData: data.content,
                processValue
            })
            this.verifyClientsId(data, false);
        } else {
            pListData = this.estateContent.getData();
            this.setState({
                contentData: {},
                processValue
            })
        }
        this.extractPList(pListData);
    }

    countProcessVlue(data) {
        let processValue = 0;
        if (data) {
            const allLength = 17;
            const hasInfosKey = data.hasOwnProperty('INFOS');
            const crtLength = hasInfosKey ? Object.keys(data).length - 1 : Object.keys(data).length;
            processValue = crtLength / allLength * 100;
            console.log('crtLength', crtLength)
        }
        return processValue;
    }

    initGlobalData() {
        globalData.singleArr = [];
        globalData.dataINFO = {};
    }

    //1.将所有user提取到一个arr，根据名字去重
    //2.没有id的user重新分配一个id
    //3.拿有id的arr与现有data进行比对，同名的user赋值id
    //hasId:旧数据没有id的自动添加id
    verifyClientsId(data, hasId = true) {
        const contentObj = data.content;
        console.log(contentObj);
        if (!contentObj.hasOwnProperty("INFOS")) {
            const infos = this.extractInfoToArr(contentObj["INFO"]);
            contentObj["INFOS"] = infos;
        }
        const singleArr = this.extractSingleClient(contentObj, hasId);
        globalData.singleArr = singleArr;
        this.insertAttrToData(singleArr, contentObj);
    }

    extractInfoToArr(data) {
        //phone;unit;street;city;state;zipcode
        let addrObjP = data["P.H.Addr."];
        addrObjP["phone"] = data["P.H.Pho"];
        let addrObjS = data["S.H.Addr."];
        addrObjS["phone"] = data["S.H.Pho"];
        let rcP = (data["P.SEX"] === "male") ? "Spouse's;Husband" : "Spouse's;Wife";
        let rcS = (data["P.SEX"] === "male") ? "Client's;Wife" : "Client's;Husband";
        const arr = [{
            ".CHO.N.": data["S.F.Name"],
            ".CHO.R.C.": rcS,
            ".CHO.AddrNPho": addrObjS,
            "id": "2",
            "type": SPOUSE,
        }, {
            ".CHO.N.": data["P.F.Name"],
            ".CHO.R.C.": rcP,
            ".CHO.AddrNPho": addrObjP,
            "id": "1",
            "type": CLIENT,
        }]
        return arr;
    }

    extractSingleClient(contentObj, hasId) {
        let allClientArr = [];
        for (const key in contentObj) {
            const objArr = contentObj[key];
            if (objArr instanceof Array) {
                for (const obj of objArr) {
                    if (!obj.hasOwnProperty("type")) {
                        if (obj.hasOwnProperty("P.H.Name")) {
                            obj["id"] = "1";
                            obj["type"] = CLIENT;
                        } else if (obj.hasOwnProperty("S.H.Name")) {
                            obj["id"] = "2";
                            obj["type"] = SPOUSE;
                        } else if (obj.hasOwnProperty("RC")) {
                            obj["type"] = CHILD;
                        } else {
                            obj["type"] = NORMAL;
                        }
                    }
                    allClientArr.push(obj);
                }
            }
        }
        let singleArr = [];
        if (hasId) {
            singleArr = deduplicationObjArr(allClientArr, "id");
        } else {
            singleArr = deduplicationObjArr(allClientArr, ".CHO.N.");
            for (const obj of singleArr) {
                if (!obj.hasOwnProperty("id")) {
                    obj["id"] = newId();
                }
            }
        }
        console.log("singdArr", hasId, singleArr);
        return singleArr;
    }

    insertAttrToData(singleArr, contentObj) {
        for (const key in contentObj) {
            const objArr = contentObj[key];
            if (objArr instanceof Array) {
                for (const obj of objArr) {
                    for (const singleObj of singleArr) {
                        if (singleObj.hasOwnProperty(".CHO.N.") && obj.hasOwnProperty(".CHO.N.")) {
                            if (singleObj[".CHO.N."] === obj[".CHO.N."]) {
                                obj["id"] = singleObj["id"];
                                obj["type"] = singleObj["type"];
                            }
                        }
                    }
                }
            }
        }
        console.log("end obj：", contentObj)
    }

    handleMenuIndex(index) {
        this.setState(() => ({
            menuIndex: index
        }))
    }

    handleNext() {
        const {menuIndex} = this.state;
        const doNext = this.estateContent.doNext();
        const data = this.estateContent.getData();
        if (doNext) {
            this.extractSpouseAndClient(menuIndex);
            let index = menuIndex + 1;
            if (index === 8 || index === 16) index += 2;
            const processValue = this.countProcessVlue(data.content);
            this.setState(() => ({
                menuIndex: index,
                processValue,
            }))
        } else {
            console.log("XXXXX");
            this.setState(() => ({
                showToast: true
            }))
        }
    }

    extractSpouseAndClient(menuIndex) {
        if (menuIndex === 1) {
            const data = this.estateContent.getData();
            const infoData = data.content["INFO"];
            const spouseInfo = {};
            const clientInfo = {};

            spouseInfo["id"] = infoData["id"];
            spouseInfo["type"] = infoData["type"];
            spouseInfo[".CHO.Em."] = infoData["S.Em"];
            spouseInfo[".CHO.N."] = infoData["S.F.Name"];
            spouseInfo[".CHO.AddrNPho"] = infoData["S.H.Addr."];
            spouseInfo[".CHO.Addr"] = infoData["S.H.Addr."];
            spouseInfo["S.H.Pho"] = infoData["S.H.Pho"];
            spouseInfo["S.W.Pho"] = infoData["S.W.Pho"];
            spouseInfo[".CHO.R.C."] = (infoData["P.SEX"] === "male") ? "Client's;Wife" : "Client's;Husband";
            spouseInfo["rc"] = "Client's";
            spouseInfo["relation"] = (infoData["P.SEX"] === "male") ? "Wife" : "Husband";
            globalData.spouseInfo = spouseInfo;

            clientInfo["id"] = infoData["id"];
            clientInfo["type"] = infoData["type"];
            clientInfo[".CHO.Em."] = infoData["P.Em"];
            clientInfo[".CHO.N."] = infoData["P.F.Name"];
            clientInfo[".CHO.AddrNPho"] = infoData["P.H.Addr."];
            clientInfo[".CHO.Addr"] = infoData["P.H.Addr."];
            clientInfo["P.H.Pho"] = infoData["P.H.Pho"];
            clientInfo["P.W.Pho"] = infoData["P.W.Pho"];
            clientInfo[".CHO.R.C."] = (infoData["P.SEX"] === "male") ? "Spouse's;Husband" : "Spouse's;Wife";
            clientInfo["rc"] = "Spouse's";
            clientInfo["relation"] = (infoData["P.SEX"] === "male") ? "Husband" : "Wife";
            globalData.clientInfo = clientInfo;
        }
    }

    handlePrev() {
        const {menuIndex} = this.state;
        let index = menuIndex - 1;
        if (index === 9 || index === 17) index -= 2;
        this.setState(() => ({
            menuIndex: index
        }))
    }

    handleCreate(isCreate) {
        const doNext = this.estateContent.doNext();
        if (isCreate) {
            if (doNext) {
                this.setState({
                    showAlert: true
                })
            } else {
                this.setState({
                    showToast: true
                })
            }
            return;
        }

        let obj = this.estateContent.getData();
        let contentObj = obj.content;
        // this.rmSpouse(contentObj);
        this.props.handleCreate(obj, isCreate);

    }

    handleCancel() {
        this.props.handleCancel();
    }

    handleClose() {
        this.setState(() => ({
            showToast: false
        }))
        globalData.toastMsg = "Please fill in the complete information";
    }

    handleDown() {
        this.setState({
            dragData: globalData.dragData
        }, () => {
            this.estateContent.handleDown();
        })
    }

    handleUp() {
        if (globalData.isCollision) {
            this.setState(() => ({
                dragData: globalData.dragData
            }))
        } else {
            this.setState(() => ({
                dragData: null
            }))
        }
        this.estateContent.handleUp();
    }

    handleMove(obj) {
        const {offsetL, offsetT, prevState} = this.state;
        let rect1 = obj;
        let rect2 = this.estateContent ? this.estateContent.getContentRectData() : null;
        if (!rect1 || !rect2) return;
        rect2.left -= offsetL;
        rect2.top -= offsetT;
        const isCollision = egdeCollisions(rect1, rect2);
        if (prevState !== isCollision) {
            globalData.isCollision = isCollision;
            this.setState(() => ({
                prevState: isCollision
            }));
            if (isCollision) {
                this.estateContent.handleCollision();
            } else {
                this.estateContent.handleLeave();
            }
        }
    }

    handleAlertYes() {
        this.setState({
            showAlert: false
        })
        let obj = this.estateContent.getData();
        let contentObj = obj.content;
        this.rmSpouse(contentObj);
        this.props.handleCreate(obj, true);
    }

    handleAlertNo() {
        this.setState({
            showAlert: false
        })
    }

    handleChange(name, value) {
        const data = this.estateContent.getData();
        if (name === 'D.T') return;
        this.extractPList(data, name, value);
        this.verifyClientsId(data);
    }

    extractPList(data, name, value) {
        if (!data) return [];
        const contentObj = data.content;
        if (contentObj["INFO"]) globalData.dataINFO = contentObj["INFO"];
        let pList = [];
        for (const key in contentObj) {
            const objArr = contentObj[key];
            if (objArr instanceof Array) {
                for (const obj of objArr) {
                    if (obj.hasOwnProperty(".CHO.N.")) {
                        if (obj[".CHO.N."].trim()) {
                            if (!obj.hasOwnProperty(".CHO.Em.")) obj[".CHO.Em."] = "";
                            pList.push(obj);
                        }
                    }
                    if (obj.hasOwnProperty("N.")) {
                        if (obj["N."].trim()) {
                            obj[".CHO.N."] = obj["N."];
                            obj[".CHO.AddrNPho"] = obj["AddrNPho"];
                            obj["rc"] = obj["rc"] ? obj["rc"] : "Our";
                            obj["relation"] = obj["relation"] !== "" ? obj["relation"] : obj["RC"];
                            obj[".CHO.R.C."] = obj["rc"] + ";" + obj["RC"];
                            pList.push(obj);
                        }
                    }
                }
            }
        }
        const emailArr = this.extractEmailArr(pList);
        const newEmailArr = deduplicationObjArr(emailArr, ".CHO.N.");
        let pListData = deduplicationObjArr(pList, "id");
        let arr = [];
        if (value) {
            arr = value;
        } else {
            arr = newEmailArr;
        }
        if (arr.length > 0) {
            for (const obj1 of pListData) {
                for (const obj2 of arr) {
                    if (obj1.hasOwnProperty(".CHO.Em.") && obj2.hasOwnProperty(".CHO.Em.")) {
                        if (obj1[".CHO.N."] === obj2[".CHO.N."]) {
                            obj1[".CHO.Em."] = obj2[".CHO.Em."];
                        }
                    }
                }
            }
        }
        console.log("pListData", pListData)
        globalData.pListData = pListData;
        this.setState({
            pListData
        })
    }

    extractEmailArr(data) {
        let arr = [];
        for (const obj of data) {
            if (obj.hasOwnProperty(".CHO.Em.")) {
                if (obj[".CHO.Em."] !== "") {
                    arr.push(obj);
                }
            }
        }
        return arr;
    }

    updateInfoData(panelData) {
        const type = panelData.type;
        if (type === CHILD || type === NORMAL) {
            this.estateContent.uploadChildNormalToAllData(panelData);
        } else {
            this.setDataInfo(panelData, (dataINFO) => {
                this.estateContent.setToAllData("INFO", dataINFO, () => {
                    this.estateContent.updateInfoToAllData();
                });
            });
        }
    }

    setDataInfo(panelData, callback = null) {
        const dataINFO = globalData.dataINFO;
        for (const key in panelData) {
            if (Object.hasOwnProperty.call(panelData, key)) {
                for (const key2 in dataINFO) {
                    if (Object.hasOwnProperty.call(dataINFO, key2)) {
                        if (key === key2) {
                            dataINFO[key2] = panelData[key];
                        }
                    }
                }
            }
        }
        if (callback) callback(dataINFO);
    }

    rmSpouse(contentObj) {
        for (const key in contentObj) {
            if (contentObj.hasOwnProperty(key)) {
                const element = contentObj[key];
                if (this.rmSpouseKey(key)) {
                    element.shift();
                }
            }
        }
    }

    rmSpouseKey(key) {
        if (key === "Ex") {//3
            return false;
        } else if (key === "Gu") {//4
            return true;
        } else if (key === "POA") {//5
            return false;
        } else if (key === "C.W.S.P.R") {//8
            return false;
        } else if (key === "C.F.S.P.R") {//9
            return false;
        } else if (key === "S.Ex") {//11
            return false;
        } else if (key === "S.Gu") {//12
            return true;
        } else if (key === "S.POA") {//13
            return false;
        } else if (key === "S.W.S.P.R") {//16
            return false;
        } else if (key === "S.F.S.P.R") {//17
            return false;
        } else if (key === "TRUSTEE") {//19
            return false;
        } else {
            return false;
        }
    }

    isNext(type) {
        const {
            menuData,
            menuIndex,
        } = this.state;
        if (type === "next") {
            return (menuIndex >= menuData.length - 1);
        } else if (type === "prev") {
            return (menuIndex <= 0);
        }
    }

    isLock() {
        return true;
    }

    isDisabled() {
        const {state} = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
}

export default EstateInfo;